import React, { Component, useState, useEffect, useMemo, useRef, forwardRef } from "react";
import axios from "axios";

import moment from "moment";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Spinner } from "reactstrap";
import { ReactTabulator } from "react-tabulator";
import CFormFields from "common/Form/CFormFields";
//import ProductAndService from "views/Finance/PurchaseDetails/ProductAndService";
import { notifier, http } from "common";
import "react-tabulator/lib/styles.css"; // required styles
//import "react-tabulator/lib/css/bootstrap/tabulator_bootstrap4.min.css"; // theme
import "react-tabulator/lib/css/semantic-ui/tabulator_semantic-ui.min.css"; // theme
import "../table-custom.css";
import { tableMgrApi } from "properties/config.json";



import addButton from "icons/edit_add.png";
import rejectButton from "icons/cancel.png";
import forwardButton from "icons/redo.png";
import deleteButton from "icons/edit_remove.png";
import editButton from "icons/pencil.png";
import reloadButton from "icons/reload.png";
import csvButton from "icons/csv.png";
import excelButton from "icons/excel.png";
import pdfButton from "icons/pdf.png";
import helpButton from "icons/helpnew.jpg";
import saveButton from "icons/filesave.png";
import submitButton from "icons/ok.png";
import downloadButton from "icons/download.png";


import {
  faSync,
  faFileExcel,
  faFilePdf,
  faFileCsv,
  faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import Iframe from "react-iframe";
import cancel from "images/cross_cancel.jpg";

import { COMMON_PROPERTIES, EXPORT_PROPERTIES } from "properties/client";
import { customFormats, transformErrors } from "common/validation";
import Form from "react-jsonschema-form";
import CFormSchemaBuilder, { customWidgets } from "common/Form/CFormComponenet";

const additionalMetaSchemas = require("ajv/lib/refs/json-schema-draft-04.json");

const exportDateFormat = COMMON_PROPERTIES.EXPORT_DATE_FORMAT;
// eslint-disable-next-line
let formData = {};


// Row and Cells are re-rendering for all state changes, not just data
// https://github.com/ngduc/react-tabulator/issues/82
const ReactTabulatorWrapper = forwardRef((props, ref) => {

  useEffect(() => {
    if (props.ref1 && props.ref1.table) {
      const oldColumns = props.ref1.table.getColumns();
      if (oldColumns === undefined || oldColumns.length <= 0) {
        props.ref1.table.setColumns([...props.columns]);
      }
    }
  }, [ref]);

  return (
    <ReactTabulator {...props} columns={[]} ref={ref} />
  );
});


class CTable extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      //PopUP
      profileChangeReadAccess: "",
      profileChangeWriteAccess: "",
      profileApplicationIds: "",
      profileDataValue: [],

      surveyDataValue: [],
      expsecrecrecid: "",

      expenditureDataValue: [],
      expendituredetrecid: "",

      editorSubmitButtonProp: false,
      NeprofileChangeReadAccess: "",
      NeprofileChangeWriteAccess: "",
      NeprofileApplicationIds: "",
      NeprofileDataValue: [],
      DefaultProfileName: "",
      DefaultProfileId: "",
      DefaultProfileVersion: "",
      DefaultOldProfileName: "",

      NeProfileName: "",
      NeProfileNeId: "",
      NeProfileVersion: "",
      Nename: "",


      guiguiuserprfusername: "",
      guiguiuserprfprofilename: "",
      guioldguiuserprfprofilename: "",
      studentAttApprovalList: [],
      studentAcademicApprovalList: [],
      AcademicPaymentApprovalList: [],
      exindiaAttendanceApprovalList: [],
      userLoginName: props.userdetloginname,
      large: false,
      savemodal: false,
      deletePopUp: false,
      danger: false,
      helpWindow: false,
      saveprofiledet: false,
      saveneprofiledet: false,
      // Modal name
      modalType: "",
      data: [],
      duplicateData: {},
      //Form attr
      param: {},
      formData: null,
      formTitle: "",
      formSchema: {},
      uiSchema: {},
      iconName: "",

      formKey: props.id + "_Form",
      downloadButtonProp: true,
      editorDeleteButtonProp: true,
      editorSaveButtonProp: false,
      key: 1,
      loading: false,
    };
    // Table ref
    // this.tableRef = React.createRef();
    this.setLoading = this.setLoading.bind(this);
    this.toggleLarge = this.toggleLarge.bind(this);
    this.toggleDelete = this.toggleDelete.bind(this);
    this.toggleDanger = this.toggleDanger.bind(this);
    this.toggleSaveProfile = this.toggleSaveProfile.bind(this);
    this.toggleSubmitSurvey = this.toggleSubmitSurvey.bind(this);
    this.toggleSubmitExpenditure = this.toggleSubmitExpenditure.bind(this);
    this.toggleSubmit = this.toggleSubmit.bind(this);
    this.storeOldValue = this.storeOldValue.bind(this);
    this.inlineEdit = this.inlineEdit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onOpenAddForm = this.onOpenAddForm.bind(this);
    this.toggleHelpWindow = this.toggleHelpWindow.bind(this);
  }
  ref = null;

  setLoading(loadingState) {
    if (this._isMounted) this.setState({ loading: loadingState });
  }

  toggleLarge() {
    this.setState({
      large: !this.state.large,
    });
  }

  togglesaveModal() {
    console.log("calling form toggle....");
    this.setState({
      savemodal: !this.state.savemodal,
    });
  }

  toggleDelete() {
    this.setState({
      deletePopUp: !this.state.deletePopUp,
    });
  }

  toggleSaveProfile() {
    this.setState({
      saveprofiledet: !this.state.saveprofiledet,
    })
  }



  toggleDanger() {
    this.setState({
      danger: !this.state.danger,
    });
  }

  storeOldValue({ duplicateParam }) {
    const data = this.state.formData;
    if (duplicateParam !== undefined && this.state.formData) {
      let duplicateData = this.state.duplicateData;
      var dupParamArr = duplicateParam.split(",");
      for (var i = 0; i < dupParamArr.length; i++) {
        const key = "old" + dupParamArr[i];
        duplicateData[key] = data[dupParamArr[i]];
      }
      this.setState({ duplicateData: duplicateData });
    }
  }
  onOpenAddForm = (options) => {
    if (this.props.onOpenAddFormCustom) {
      this.props.onOpenAddFormCustom(options);
      return;
    }


    const { parentTableData } = this.props;
    this.setState({ param: this.props.addOption });
    if (
      parentTableData !== undefined &&
      Object.keys(parentTableData).length === 0
    ) {
      this.setState({ modalType: " Add" });
      this.toggleDanger();
    } else this.popUpLoadForm(this.props.addOption);
  };
  onOpenForwardEditForm = (options) => {
    const { formData } = this.state;
    this.storeOldValue(this.props);
    this.setState({ param: this.props.ForwardOption });
    if (Object.keys(formData).length !== 0) {
      this.popUpLoadForm(this.props.ForwardOption);
    } else {
      this.setState({ modalType: " Forward" });
      this.toggleDanger();
    }
  };
  onRejectEditForm = (options) => {
    const { formData } = this.state;
    this.storeOldValue(this.props);
    this.setState({ param: this.props.RejectOption });
    if (Object.keys(formData).length !== 0) {
      this.popUpLoadForm(this.props.RejectOption);
    } else {
      this.setState({ modalType: " Reject" });
      this.toggleDanger();
    }
  };
  onOpenEditForm = (options) => {
    console.log(options);
    const { formData } = this.state;
    this.storeOldValue(this.props);
    this.setState({ param: this.props.editOption });
    if (Object.keys(formData).length !== 0) {
      if (this.props.onOpenEditFormCustom) {
        console.log("options" + options);
        console.log("formData" + formData);
        this.props.onOpenEditFormCustom(options, formData);
        return;
      }
      this.popUpLoadForm(this.props.editOption);
    } else {
      this.setState({ modalType: " Edit" });
      this.toggleDanger();
    }
  };
  handleAdditionalOptionsClick = (iconName) => {
    const { formData } = this.state;
    const matchedOptions = this.props.additionalOptions.filter(x => x.iconName == iconName);
    if (matchedOptions.length > 0) {
      const matchedOption = matchedOptions[0];
      if (matchedOption.action) { matchedOption.action(matchedOption, formData); }
    }
  };
  onOpenDeleteForm = (options) => {
    const formData = this.state.formData;
    if (Object.keys(formData).length !== 0) {
      // Validation check 
      if (this.props.onOpenDeleteFormCustom && this.props.deleteProperties === false) {
        this.props.onOpenDeleteFormCustom(options, formData);
        return;
      }
      this.setState({ formTitle: options.title });
      this.toggleDelete();
    } else {
      this.setState({ modalType: "  Delete" });
      this.toggleDanger();
    }
  };

  onOpenSaveForm = (options, id) => {
    console.log(options);

    const { profileDataValue, profileApplicationIds, profileChangeWriteAccess, profileChangeReadAccess, studentAttApprovalList, exindiaAttendanceApprovalList, studentAcademicApprovalList, AcademicPaymentApprovalList } = this.state;
    console.log(studentAttApprovalList);
    console.log(studentAcademicApprovalList);
    console.log(AcademicPaymentApprovalList);
    console.log(exindiaAttendanceApprovalList);
    let data = [];
    if (id === "TrackStudentAttendance") {
      if (studentAttApprovalList.length == 0) {
        this.toggleSaveProfile();
      } else {
        this.savepopUpLoadForm(this.props.saveOption, id);
        console.log("getting data", studentAttApprovalList);
      }
    } else if (id === "TrackStudentAcademic") {
      if (studentAcademicApprovalList.length == 0) {
        this.toggleSaveProfile();
      } else {
        this.savepopUpLoadForm(this.props.saveOption, id);
        console.log("getting data", studentAcademicApprovalList);
      }
    } else if (id === "PaymentReleaseConfirmation") {
      if (AcademicPaymentApprovalList.length == 0) {
        this.toggleSaveProfile();
      } else {
        this.savepopUpLoadForm(this.props.saveOption, id);
        console.log("getting data", AcademicPaymentApprovalList);
      }
    } else if (id === "TrackExIndianStudentAttendance") {
      if (exindiaAttendanceApprovalList.length == 0) {
        this.toggleSaveProfile();
      } else {
        this.savepopUpLoadForm(this.props.saveOption, id);
        console.log("getting data", exindiaAttendanceApprovalList);
      }
    } else if (id === "SurveyQestions") {
      if (this.state.surveyDataValue.length == 0) {
        this.toggleSaveProfile();
      } else {
        http
          .getDataFromServer(tableMgrApi, {
            QueryNum: "6940",
            Parm1: this.props.submitOptions.entityId,
            Parm2: this.props.submitOptions.surveydate,
            key: "SURVEY_QUESTIONS",
            OperationKey: "SURVEY_QUESTIONS",
          })
          .then(({ status, rows }) => {
            if (status === "Success" && rows.length > 0) {
              data.svydetrecid = rows[0].svydetrecid;
              let svydetstatus = rows[0].svydetstatus;
              if (svydetstatus == 2) {
                this.toggleSubmitSurvey();
              } else {
                data.surveyData = JSON.stringify(this.state.surveyDataValue);
                this.processBackEnd(data, this.props.saveOption);
                this.state.surveyDataValue = [];
              }
            } else {
              this.toggleSaveProfile();
            }
          });
      }
    }
    else if (id === "RecordMonthlyReceiptExpenditure") {
      console.log(" this.state.formData", this.state.expenditureDataValue);
      if (this.state.expenditureDataValue.length == 0) {
        this.toggleSaveProfile();
      } else {
        http
          .getDataFromServer(tableMgrApi, {
            QueryNum: "5527",
            Parm1: this.props.submitOptions.entityId,
            Parm2: this.props.submitOptions.expendituredate,
            key: "SURVEY_QUESTIONS",
            OperationKey: "SURVEY_QUESTIONS",
          })
          .then(({ status, rows }) => {
            if (status === "Success" && rows.length > 0) {
              data.expsecrecrecid = rows[0].expsectiondetrecid;
              let expsectiondetstatus = rows[0].expsectiondetstatus;
              if (expsectiondetstatus == 2) {
                this.toggleSubmitSurvey();
              } else {
                data.expenditureData = JSON.stringify(this.state.expenditureDataValue);
                this.processBackEnd(data, this.props.saveOption);
                this.state.expenditureDataValue = [];
              }
            } else {
              this.toggleSaveProfile();
            }
          });
      }

    }
    else {
      if (profileApplicationIds === "") {
        this.toggleSaveProfile();
      } else {
        data.applications = profileDataValue;
        data.guiappsinprofappid = profileApplicationIds;
        data.guiappsinprofreadaccess = profileChangeReadAccess;
        data.guiappsinprofwriteaccess = profileChangeWriteAccess;
        this.processBackEnd(data, this.props.saveOption);
        this.state.profileDataValue = [];
        this.state.profileApplicationIds = "";
        this.state.profileChangeReadAccess = "";
        this.state.profileChangeWriteAccess = "";

      }
    }
  };
  //Start Submit Survey Questions //
  toggleSubmitSurvey() {
    this.setState({
      submit: !this.state.submit,
    })
    this.loadData("Reload")
  }
  toggleSubmitExpenditure() {
    this.setState({
      submitExp: !this.state.submitExp,
    })
    this.loadData("Reload")
  }

  toggleSubmit() {
    let { loadFormData } = this.props;
    setTimeout(() => {
      if (loadFormData) loadFormData(this.props.submitOptions, this.state.formData);
    });
    this.setState({
      submitPopUp: !this.state.submitPopUp,
    });
  }
  onOpenSubmitForm = (options, id) => {
    console.log(this.props.submitOptions);
    if (id === "SurveyQestions") {
      http
        .getDataFromServer(tableMgrApi, {
          QueryNum: "6940",
          Parm1: this.props.submitOptions.entityId,
          Parm2: this.props.submitOptions.surveydate,
          key: "SURVEY_QUESTIONS",
          OperationKey: "SURVEY_QUESTIONS",
        })
        .then(({ status, rows }) => {
          if (status === "Success" && rows.length > 0) {
            this.setState({ svydetrecid: rows[0].svydetrecid });
            // data.svydetrecid = rows[0].svydetrecid;
            let svydetstatus = rows[0].svydetstatus;
            if (svydetstatus == 2) {
              this.toggleSubmitSurvey();
            } else {
              this.toggleSubmit();
            }
          } else {
            this.toggleSaveProfile();
          }
        });
    } else if (id === "RecordMonthlyReceiptExpenditure") {
      http
        .getDataFromServer(tableMgrApi, {
          QueryNum: "5527",
          Parm1: this.props.submitOptions.entityId,
          Parm2: this.props.submitOptions.expendituredate,
          key: "EXPENDITURESECTIONRECORDS",
          OperationKey: "EXPENDITURESECTIONRECORDS",
        })
        .then(({ status, rows }) => {
          if (status === "Success" && rows.length > 0) {
            this.setState({ expsecrecrecid: rows[0].expsectiondetrecid });
            let expsectiondetstatus = rows[0].expsectiondetstatus;
            if (expsectiondetstatus == 2) {
              this.toggleSubmitExpenditure();
            } else {
              this.toggleSubmit();
            }
          } else {
            this.toggleSaveProfile();
          }
        });
    }
  };

  onSubmitRecord = () => {
    let data = [];
    if (this.props.id === "SurveyQestions") {
      data.svydetrecid = this.state.svydetrecid;
      data.surveyData = JSON.stringify(this.state.surveyDataValue);
      this.processBackEnd(data, this.props.submitOptions);
      this.state.surveyDataValue = [];
      this.toggleSubmit();
    } else if (this.props.id === 'RecordMonthlyReceiptExpenditure') {
      data.expsecrecrecid = this.state.expsecrecrecid;
      http
        .getDataFromServer(tableMgrApi, {
          QueryNum: "5519",
          Parm1: this.props.submitOptions.expendituredate,
          Parm2: this.props.submitOptions.entityId,
          key: "EXPENDITURESECTIONRECORDS",
          OperationKey: "EXPENDITURESECTIONRECORDS",
        })
        .then(({ status, rows }) => {
          if (status === "Success" && rows.length > 0) {
            console.log(rows);
            if (!data.expenditureData) { // Check if data.expenditureData is not already initialized
              data.expenditureData = []; // Initialize data.expenditureData as an empty array
            }
            data.expenditureData = JSON.stringify(rows);
            this.processBackEnd(data, this.props.submitOptions);
            this.state.expenditureDataValue = [];
            this.toggleSubmit();
          }
        })

    }

  };
  //End Submit Survey Questions //



  onOpenSaveDefaultProfileForm = (options) => {
    const { DefaultProfileName, DefaultProfileId, DefaultProfileVersion, DefaultOldProfileName } = this.state;
    console.log("on open Save default profile form");
    let data = [];
    data.neprofilename = this.state.DefaultProfileName;
    data.neversionnumber = this.state.DefaultProfileVersion;
    data.oldneprofilename = this.state.DefaultOldProfileName;
    console.log("Login Name " + this.state.userLoginName);
    this.processBackEnd(data, this.props.saveOptionDefaultProfile);
  };


  onOpenSaveNeProfileForm = (options) => {
    const { NeProfileName, Nename, NeProfileVersion, NeProfileNeId, DefaultOldProfileName } = this.state;
    console.log("on open Save Ne profile form");
    let data = [];
    data.neprofilename = this.state.NeProfileName;
    data.neid = this.state.NeProfileNeId;
    data.nename = this.state.Nename;
    data.oldneprofilename = this.state.DefaultOldProfileName;
    this.processBackEnd(data, this.props.saveOptionNeprofile);
  };

  onOpenSaveGuiProfileForm = (options) => {
    const { guiguiuserprfprofilename, guioldguiuserprfprofilename } = this.state;
    console.log("on open Save Ne profile form");
    let data = [];
    data.guiuserprfprofilename = this.state.guiguiuserprfprofilename;
    data.oldguiuserprfprofilename = this.state.guioldguiuserprfprofilename;
    this.processBackEnd(data, this.props.saveOptionGuiProfile);
  };



  onOpenSaveNeForm = (options) => {
    const { NeprofileDataValue, NeprofileApplicationIds, NeprofileChangeWriteAccess, NeprofileChangeReadAccess } = this.state;
    let data = [];
    if (NeprofileApplicationIds === "") {
      this.toggleSaveProfile();
    } else {
      data.applications = NeprofileDataValue;
      data.neappsinprofappid = NeprofileApplicationIds;
      data.neappsinprofreadaccess = NeprofileChangeReadAccess;
      data.neappsinprofwriteaccess = NeprofileChangeWriteAccess;
      this.processBackEnd(data, this.props.saveOptionNe);
      this.state.NeprofileDataValue = [];
      this.state.NeprofileApplicationIds = "";
      this.state.NeprofileChangeReadAccess = "";
      this.state.NeprofileChangeWriteAccess = "";

    }

  }


  rowClick = (e, row) => {
    const { DefaultOldProfileName } = this.state;
    if (row._row.data.neprofilename) {
      console.log("Yes profilename");
      this.state.DefaultOldProfileName = row._row.data.neprofilename;
      console.log("Row ", row);
    }
    if (row._row.data.guiuserprfprofilename) {
      console.log("Yes guiuserprfprofilename");
      this.state.guioldguiuserprfprofilename = row._row.data.guiuserprfprofilename;
      console.log("Row ", row);
    }
    const { inlineEditFlag, booleanField } = this.props;

    let formData = row.getData();
    if (booleanField) {
      console.log("Boolean field");
      const fieldArr = booleanField.split(",");
      for (var i = 0; i <= fieldArr.length - 1; i++) {
        const field = fieldArr[i];
        if (formData[field] === 1) formData[field] = true;
        else formData[field] = false;
      }
    }
    if (!inlineEditFlag) {
      console.log("Not inlineEditFlag");
      console.log("Not inlineEditFlag" + this.props.id);

      this.setState({ formData, editorDeleteButtonProp: false });
      console.log("form::" + formData);

      // if (this.props.id != 'RecordMonthlyReceiptExpenditure') {
      //   this.setState({ formData, editorDeleteButtonProp: false });
      //   console.log("form::")
      // } else {
      //   this.setState({ formData, editorDeleteButtonProp: true });
      //   console.log("form::")
      // }
      //console.log("form::")
    }
    if (this.props.updateParentProp) {
      console.log("this.updateParentProp");
      this.props.updateParentProp(formData);
    }
  };

  popUpLoadForm(options) {
    let { loadFormData, uiSchema, formSchema } = this.props;
    if (loadFormData) {
      let loadFormDataResult = loadFormData(options, this.state.formData);
      if ((loadFormDataResult !== undefined) && (loadFormDataResult.formData !== undefined)) {
        this.setState({ formData: loadFormDataResult.formData });
      }
    }
    setTimeout(() => {
      let {
        formSchema: formSchemaData,
        uiSchema: uiSchemaData,
        title,
        iconName,
      } = options;
      if (!formSchemaData) formSchemaData = formSchema;
      let formAlighnSchema = CFormSchemaBuilder(formSchemaData);
      if (!uiSchemaData) uiSchemaData = uiSchema;
      if (uiSchemaData)
        formAlighnSchema = { ...formAlighnSchema, ...uiSchemaData };
      if (formSchemaData.loadForm !== false) {
        this.setState({
          formSchema: formSchemaData,
          formTitle: title,
          iconName: iconName,
          uiSchema: formAlighnSchema,
        });
        this.toggleLarge();
      }
    }, 300);
  }

  savepopUpLoadForm(options, id) {
    let { loadFormData, uiSchema, formSchema } = this.props;
    console.log("loadFormD");
    console.log(loadFormData);
    console.log(uiSchema);
    console.log(formSchema);
    // if (loadFormData) loadFormData(options, this.state.formData);
    setTimeout(() => {

      // if (!formSchemaData) formSchemaData = formSchema;
      // let formAlighnSchema = CFormSchemaBuilder(formSchemaData);
      // if (!uiSchemaData) uiSchemaData = uiSchema;
      // if (uiSchemaData)
      //   formAlighnSchema = { ...formAlighnSchema, ...uiSchemaData };
      // if (formSchemaData.loadForm !== false) {
      if (id === "TrackStudentAttendance") {
        this.setState({
          formSchema: formSchema,
          formTitle: "Attendance details Approval",
          iconName: "Save",
          uiSchema: uiSchema,
        });
        this.togglesaveModal();

      } else if (id === "TrackStudentAcademic") {
        this.setState({
          formSchema: formSchema,
          formTitle: "Academic details Approval",
          iconName: "Save",
          uiSchema: uiSchema,
        });
        this.togglesaveModal();

      } else if (id === "PaymentReleaseConfirmation") {
        this.setState({
          formSchema: formSchema,
          formTitle: "Academic Payment Approval",
          iconName: "Save",
          uiSchema: uiSchema,
        });
        this.togglesaveModal();

      } else if (id === "TrackExIndianStudentAttendance") {
        this.setState({
          formSchema: formSchema,
          formTitle: "Ex-India Student Attendance Approval",
          iconName: "Save",
          uiSchema: uiSchema,
        });
        this.togglesaveModal();

      }

      // }
    }, 300);
  }

  inlineEdit = (cell, saveOptions, id, submitOptions) => {
    //Please enable the checkbox state and then Update

    console.log("cell : ", cell.getRow());
    console.log("saveOptions : ", saveOptions);
    console.log("id : ", id);
    const { NeProfileName, Nename, NeProfileVersion, NeProfileNeId, studentAttApprovalList, exindiaAttendanceApprovalList, studentAcademicApprovalList, AcademicPaymentApprovalList } = this.state;
    const { DefaultProfileName, DefaultProfileId, DefaultProfileVersion } = this.state;
    const { profileDataValue, profileChangeReadAccess, profileChangeWriteAccess, profileApplicationIds } = this.state;
    const { NeprofileDataValue, NeprofileChangeReadAccess, NeprofileChangeWriteAccess, NeprofileApplicationIds } = this.state;
    if (id === 'guiappsprofile') {
      if (saveOptions) {
        let data = cell.getRow().getData();
        Object.keys(data).map((name) => {
          return data[name] === true
            ? (data[name] = 1)
            : data[name] === false
              ? (data[name] = 0)
              : data[name];
        });

        var applicationJson = {};
        applicationJson.read = data.guiappsinprofreadaccess;
        applicationJson.write = data.guiappsinprofwriteaccess;
        applicationJson.appid = data.guiappsinprofappid;
        this.state.profileDataValue.push(applicationJson);
        if (this.state.profileApplicationIds == "") {
          this.state.profileApplicationIds = data.guiappsinprofappid + "";
        } else {
          this.state.profileApplicationIds = this.state.profileApplicationIds + "," + data.guiappsinprofappid;
        }

        if (this.state.profileChangeWriteAccess == "") {
          this.state.profileChangeWriteAccess = data.guiappsinprofwriteaccess + "";
        } else {
          this.state.profileChangeWriteAccess = this.state.profileChangeWriteAccess + "," + data.guiappsinprofwriteaccess;
        }

        if (this.state.profileChangeReadAccess == "") {
          this.state.profileChangeReadAccess = data.guiappsinprofreadaccess + "";
        } else {
          this.state.profileChangeReadAccess = this.state.profileChangeReadAccess + "," + data.guiappsinprofreadaccess;
        }
      }
    } else if (id === "neappsprofile") {

      let data = cell.getRow().getData();
      Object.keys(data).map((name) => {
        return data[name] === true
          ? (data[name] = 1)
          : data[name] === false
            ? (data[name] = 0)
            : data[name];
      });
      var applicationJson = {};
      applicationJson.read = data.neappsinprofreadaccess;
      applicationJson.write = data.neappsinprofwriteaccess;
      applicationJson.appid = data.neappsinprofappid;
      this.state.NeprofileDataValue.push(applicationJson);



      if (this.state.NeprofileApplicationIds == "") {
        this.state.NeprofileApplicationIds = data.neappsinprofappid + "";
      } else {
        this.state.NeprofileApplicationIds = this.state.NeprofileApplicationIds + "," + data.neappsinprofappid;
      }

      if (this.state.NeprofileChangeWriteAccess == "") {
        this.state.NeprofileChangeWriteAccess = data.neappsinprofwriteaccess + "";
      } else {
        this.state.NeprofileChangeWriteAccess = this.state.NeprofileChangeWriteAccess + "," + data.neappsinprofwriteaccess;
      }

      if (this.state.NeprofileChangeReadAccess == "") {
        this.state.NeprofileChangeReadAccess = data.neappsinprofreadaccess + "";
      } else {
        this.state.NeprofileChangeReadAccess = this.state.NeprofileChangeReadAccess + "," + data.neappsinprofreadaccess;
      }
    }
    else if (id === "defaultNeProfileKey") {
      let data = cell.getRow().getData();
      Object.keys(data).map((name) => {
        return data[name] === true
          ? (data[name] = 1)
          : data[name] === false
            ? (data[name] = 0)
            : data[name];
      });
      this.state.DefaultProfileName = data.neprofilename;
      this.state.DefaultProfileVersion = data.neversionnumber;
    } else if (id === "NePrivilegesProfileKey") {
      let data = cell.getRow().getData();
      Object.keys(data).map((name) => {
        return data[name] === true
          ? (data[name] = 1)
          : data[name] === false
            ? (data[name] = 0)
            : data[name];
      });
      this.state.NeProfileName = data.neprofilename;
      this.state.NeProfileNeId = data.neid;
      this.state.NeProfileVersion = data.neversionnumber;
      this.state.Nename = data.nename;
    } else if (id === "guiuserProfileTableKey") {
      let data = cell.getRow().getData();
      Object.keys(data).map((name) => {
        return data[name] === true
          ? (data[name] = 1)
          : data[name] === false
            ? (data[name] = 0)
            : data[name];
      });
      this.state.guiguiuserprfprofilename = data.guiuserprfprofilename;
      console.log("data.guiuserprfprofilename " + this.state.guiguiuserprfprofilename);
    } else if (id === "TrackStudentAttendance") {
      let data = cell.getRow().getData();
      Object.keys(data).map((name) => {
        return data[name] === true
          ? (data[name] = 1)
          : data[name] === false
            ? (data[name] = 0)
            : data[name];
      });
      const attendanceApprovalObj = {};
      attendanceApprovalObj.id = data.refid + "";
      attendanceApprovalObj.name = data.stdmonatdstudentid + "";
      attendanceApprovalObj.month = data.stdmonatdmonth + "";
      attendanceApprovalObj.approvalstate = data.attendancecheckbox + "";
      console.log(attendanceApprovalObj);
      studentAttApprovalList.push(attendanceApprovalObj);
      // this.setState({
      //   studentAttApprovalList: studentAttApprovalList

      // });
      console.log("Data", studentAttApprovalList);
    } else if (id === "TrackStudentAcademic") {
      let data = cell.getRow().getData();
      Object.keys(data).map((name) => {
        return data[name] === true
          ? (data[name] = 1)
          : data[name] === false
            ? (data[name] = 0)
            : data[name];
      });
      let AcademicApprovalObj = {};
      AcademicApprovalObj.id = data.refid + "";
      AcademicApprovalObj.name = data.studentacdmstudentid + "";
      AcademicApprovalObj.semester = data.studentacdmcsemester + "";
      AcademicApprovalObj.approvalstate = data.academiccheckbox + "";
      studentAcademicApprovalList.push(AcademicApprovalObj);
      // this.setState({
      //   studentAcademicApprovalList: studentAcademicApprovalList      //note this point your view
      // });
      console.log("Data", studentAcademicApprovalList);

    } else if (id === "PaymentReleaseConfirmation") {
      let data = cell.getRow().getData();
      Object.keys(data).map((name) => {
        return data[name] === true
          ? (data[name] = 1)
          : data[name] === false
            ? (data[name] = 0)
            : data[name];
      });
      let AcademicPaymentApprovalObj = {};
      AcademicPaymentApprovalObj.id = data.univtrnsdtlrecid + "";
      AcademicPaymentApprovalObj.name = data.univtrnsdtlinsid + "";
      AcademicPaymentApprovalObj.month = data.univtrnsdtlmonth + "";
      AcademicPaymentApprovalObj.approvalstate = data.instituecheckbox + "";
      AcademicPaymentApprovalList.push(AcademicPaymentApprovalObj);
      console.log("AcapayData", AcademicPaymentApprovalList);
      // this.setState({
      //   AcademicPaymentApprovalList: AcademicPaymentApprovalList
      // });
    } else if (id === "TrackExIndianStudentAttendance") {
      let data = cell.getRow().getData();
      Object.keys(data).map((name) => {
        return data[name] === true
          ? (data[name] = 1)
          : data[name] === false
            ? (data[name] = 0)
            : data[name];
      });
      let ExIndianStudentAttendanceApprovalObj = {};
      ExIndianStudentAttendanceApprovalObj.id = data.refid + "";
      ExIndianStudentAttendanceApprovalObj.name = data.stdmonatdstudentid + "";
      ExIndianStudentAttendanceApprovalObj.month = data.stdmonatdmonth + "";
      ExIndianStudentAttendanceApprovalObj.approvalstate = data.exindiaattendancecheckbox + "";
      exindiaAttendanceApprovalList.push(ExIndianStudentAttendanceApprovalObj);
      console.log(exindiaAttendanceApprovalList);
      // this.setState({
      //   AcademicPaymentApprovalList: AcademicPaymentApprovalList
      // });
    } else if (id === 'SurveyQestions') {// Start Survey Questions
      if (saveOptions || submitOptions) {
        let data = cell.getRow().getData();
        Object.keys(data).map((name) => {
          return data[name] === true
            ? (data[name] = 1)
            : data[name] === false
              ? (data[name] = 0)
              : data[name];
        });
        // Create a copy of the existing state
        const updatedSurveyDataValue = [...this.state.surveyDataValue];//empty
        const { svyquestionqid, svyquestionserveyid, svyquestionrecid, svyquestionanswer, svyquestionansweryes, svyquestionanswerno } = data;
        // Initialize the new value of svyquestionanswer
        let newSvyQuestionAnswer;

        // Determine the value of svyquestionanswer based on svyquestionansweryes and svyquestionanswerno
        if (svyquestionansweryes === 1) {
          newSvyQuestionAnswer = 1;
        } else if (svyquestionanswerno === 1) {
          newSvyQuestionAnswer = 0;
        }
        // Find index of the item with the same svyquestionqid and svyquestionrecid
        const indexToRemove = updatedSurveyDataValue.findIndex(item =>
          item.svyquestionqid === svyquestionqid && item.svyquestionrecid === svyquestionrecid && item.svyquestionserveyid === svyquestionserveyid
        );

        // If found, remove the item
        if (indexToRemove !== -1) {
          updatedSurveyDataValue.splice(indexToRemove, 1);
        }
        // Add the new item to the array
        updatedSurveyDataValue.push({
          svyquestionqid,
          svyquestionserveyid,
          svyquestionrecid,
          svyquestionanswer: newSvyQuestionAnswer,
        });
        console.log("updatedSurveyDataValue", updatedSurveyDataValue);
        // Find and remove any item where svyquestionanswer is undefined
        const indexToRemoveUndefined = updatedSurveyDataValue.findIndex(item => item.svyquestionanswer === undefined);
        console.log(indexToRemoveUndefined);
        if (indexToRemoveUndefined !== -1) {
          updatedSurveyDataValue.splice(indexToRemoveUndefined, 1);
        }
        console.log("removedUndefined", updatedSurveyDataValue);
        // Update the state with the modified array and other variables
        this.setState(prevState => ({
          surveyDataValue: updatedSurveyDataValue,
        }), () => {
          console.log(this.state.surveyDataValue); // Log the updated array
        });
      }
    } else if (id === 'RecordMonthlyReceiptExpenditure') {// Start Survey Questions
      if (saveOptions || submitOptions) {
        let data = cell.getRow().getData();
        Object.keys(data).map((name) => {
          return data[name] === true
            ? (data[name] = 1)
            : data[name] === false
              ? (data[name] = 0)
              : data[name];
        });
        console.log(data);
        // Create a copy of the existing state
        const updatedExpenditureDataValue = [...this.state.expenditureDataValue];
        const { expsecrecqusrecid, expsecrecqussessionid, expsecrecrecid, expsecrecqusamount } = data;
        // Initialize the new value of svyquestionanswer

        // Find index of the item with the same svyquestionqid and svyquestionrecid
        const indexToRemove = updatedExpenditureDataValue.findIndex(item =>
          item.expsecrecqusrecid === expsecrecqusrecid && item.expsecrecrecid === expsecrecrecid && item.expsecrecqussessionid === expsecrecqussessionid
        );

        // If found, remove the item
        if (indexToRemove !== -1) {
          updatedExpenditureDataValue.splice(indexToRemove, 1);
        }

        // Add the new item to the array
        updatedExpenditureDataValue.push({
          expsecrecqusrecid,
          expsecrecqussessionid,
          expsecrecrecid,
          expsecrecqusamount,
        });

        // Update the state with the modified array and other variables
        this.setState(prevState => ({
          expenditureDataValue: updatedExpenditureDataValue,
        }), () => {
          console.log(this.state.expenditureDataValue); // Log the updated array
        });
      }
    }// End Survey Questions// End Survey Questions
  };
  onDeleteRecord = () => {
    this.processBackEnd(
      { ...this.state.formData, ...this.props.deleteOption },
      this.props.deleteOption
    );
    this.toggleDelete();
  };
  handleSubmit = ({ formData }, options) => {
    if (formData) {
      Object.keys(formData).map((name) => {
        return formData[name] === true
          ? (formData[name] = 1)
          : formData[name] === false
            ? (formData[name] = 0)
            : formData[name];
      });
      this.processBackEnd(formData, this.state.param);
    }
    this.toggleLarge();
  };

  handleattendaneSubmit = ({ formData }, options) => {
    console.log("optionss", options);
    const { studentAttApprovalList } = this.state;
    const { exindiaAttendanceApprovalList } = this.state;
    const { studentAcademicApprovalList } = this.state;
    const { AcademicPaymentApprovalList } = this.state;

    if (formData) {
      Object.keys(formData).map((name) => {
        return formData[name] === true
          ? (formData[name] = 1)
          : formData[name] === false
            ? (formData[name] = 0)
            : formData[name];
      });
      if (formData.exindiainstituestatus !== undefined) {
        console.log("formData", formData);
        let finalFormData = {};
        finalFormData.stdmonatdinstituestatus = formData.exindiainstituestatus;
        finalFormData.stdmonatdremarks = formData.remark;
        finalFormData.studentAttendanceApprovalList = JSON.stringify(exindiaAttendanceApprovalList);
        console.log("exifinalFormDataatt:::::::+++++", finalFormData);
        console.log("existudentlist", exindiaAttendanceApprovalList);
        this.processBackEndforApprove(finalFormData, this.state.param);

      } else if (formData.stdmonatdinstituestatus !== undefined) {
        console.log("formData", formData);
        let finalFormData = {};
        finalFormData.stdmonatdinstituestatus = formData.stdmonatdinstituestatus;
        finalFormData.stdmonatdremarks = formData.remark;
        finalFormData.studentAttendanceApprovalList = JSON.stringify(studentAttApprovalList);
        console.log("finalFormDataatt:::::::+++++", finalFormData);
        console.log("studentlist", studentAttApprovalList);
        this.processBackEndforApprove(finalFormData, this.state.param);
      } else if (formData.studentacdinstituestatus !== undefined) {
        console.log("formData", formData);
        let finalFormData = {};
        finalFormData.studentacdinstituestatus = formData.studentacdinstituestatus;
        finalFormData.stdmonastudentacdremarkstdremarks = formData.remark;
        finalFormData.studentAcademicApprovalList = JSON.stringify(studentAcademicApprovalList);
        console.log("finalFormDataacd", finalFormData);
        console.log("studentacalist", studentAcademicApprovalList);
        this.processBackEndforApprove(finalFormData, this.state.param);

      } else if (formData.univtrnsdtlstatus !== undefined) {
        console.log("formData", formData);
        let finalFormData = {};
        finalFormData.univtrnsdtlstatus = formData.univtrnsdtlstatus;
        finalFormData.univtrnsdtlremark = formData.univtrnsdtlremark;
        finalFormData.AcademicPaymentApprovalList = JSON.stringify(AcademicPaymentApprovalList);
        console.log("finalFormDataacdpay", finalFormData);
        console.log("studentacalist", AcademicPaymentApprovalList);
        this.processBackEndforApprove(finalFormData, this.state.param);

      } else {

      }
    }
    this.togglesaveModal();
  };

  handleChange = (e, props) => {
    if (this.props.formOnChange) {
      this.props.formOnChange(e, props);
      formData = e.formData;
    }
  };

  handleblur = (e, props) => {
    if (this.props.formOnBlur) {
      this.props.formOnBlur(e, props);
      formData = e.formData;
    }
  };
  loadData = async (type) => {
    this.setLoading(true);
    const { refOption: options, updateParentProp } = this.props;

    //if (this.props.loadDataCustom) {
    //  this.props.loadDataCustom()
    //  .then(rows => {
    //    this.setState({ data: rows });
    //    if (this.props.dataLoadedHandler) { this.props.dataLoadedHandler(rows); }
    //    if (rows.length > 0) this.setState({ downloadButtonProp: false });
    //  })
    //  .catch((error) => { console.log(error); })
    //  .finally(() => { this.setLoading(false); });
    //
    //  if (type !== undefined && updateParentProp) updateParentProp({});
    //  return;
    //}

    http
      .post(options.url, options)
      .then(({ status, data }) => {
        if (status === 200 && this._isMounted) {
          this.setState({ data: data.rows });
          if (this.props.dataLoadedHandler) {
            this.props.dataLoadedHandler(data.rows);
          }
        }
        if ((data.rows.length > 0) && (this._isMounted)) this.setState({ downloadButtonProp: false });
        // if (!inlineEditFlag)
        //   this.setState({ formData: {}, editorDeleteButtonProp: false });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.setLoading(false);
      });
    if (type !== undefined && updateParentProp) updateParentProp({});
  };
  downloaddoc = async () => {
    axios({
      method: "get",
      url: process.env.REACT_APP_FILE_PATH + "Payment-Sample-Format.xlsx",
      // url:  process.env.REACT_APP_FILE_PATH+"Mentoring_Minutes_Template.xlsx",
      responseType: "arraybuffer"
    })
      .then((response) => {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/octet-stream"
          })
        );
        link.download = "Payment-Sample-Format.xlsx";

        document.body.appendChild(link);

        link.click();
        setTimeout(function () {
          window.URL.revokeObjectURL(link);
        }, 200);
      })
      .catch((error) => { });


  }

  processBackEnd = async (data, options) => {
    console.log("data ", data);
    console.log("options ", options);
    const { additionalReqParams, inlineEditFlag } = this.props;
    if (additionalReqParams) data = { ...data, ...additionalReqParams };
    if (this.state.duplicateData)
      data = { ...data, ...this.state.duplicateData };
    Object.keys(data).map(function (key) {
      if (data[key] instanceof Array) {
        let value = data[key].join(",");
        data[key] = value;
      }
      return data;
    });
    let outputData = data;
    let outputOptions = options;
    console.log(typeof options.prehandle);
    if (options.prehandle != undefined) {
      let result = options.prehandle(options, data);
      console.log(result);
      if (result !== undefined && result.data !== undefined) {
        outputData = { ...result.data };
        outputOptions = { ...result.options };
      }
    }

    http
      .post(outputOptions.url, outputData)
      //    .post(options.url, data)
      .then((response) => {
        if (response.status === 200) {
          const { message } = response.data;
          notifier.info(message.replace("^", "-"));
          if (this.props.id === "RecordMonthlyReceiptExpenditure") {
            this.loadData();
          }
          if (!inlineEditFlag) this.loadData();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  processBackEndforApprove = async (data, options) => {
    if (data.exindiainstituestatus !== undefined) {
      console.log("data ", data);
      console.log("options ", options);
      const { additionalReqParams, inlineEditFlag } = this.props;
      if (additionalReqParams) data = { ...data, ...additionalReqParams };
      if (this.state.duplicateData)
        data = { ...data, ...this.state.duplicateData };
      Object.keys(data).map(function (key) {
        if (data[key] instanceof Array) {
          let value = data[key];
          data[key] = value;
        }
        return data;
      });
      // let jsonvar = data;
      // console.log("data= ", jsonvar);
      http
        .post("/studentsAttendanceMultipleApproval", data)
        .then((response) => {
          if (response.status === 200) {
            const { message } = response.data;
            notifier.info(message.replace("^", "-"));
            if (!inlineEditFlag) this.loadData();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (data.stdmonatdinstituestatus !== undefined) {
      console.log("data ", data);
      console.log("options ", options);
      const { additionalReqParams, inlineEditFlag } = this.props;
      if (additionalReqParams) data = { ...data, ...additionalReqParams };
      if (this.state.duplicateData)
        data = { ...data, ...this.state.duplicateData };
      Object.keys(data).map(function (key) {
        if (data[key] instanceof Array) {
          let value = data[key];
          data[key] = value;
        }
        return data;
      });
      // let jsonvar = data;
      // console.log("data= ", jsonvar);
      http
        .post("/studentsAttendanceMultipleApproval", data)
        .then((response) => {
          if (response.status === 200) {
            const { message } = response.data;
            notifier.info(message.replace("^", "-"));
            if (!inlineEditFlag) this.loadData();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (data.studentacdinstituestatus !== undefined) {
      console.log("data ", data);
      console.log("options ", options);
      const { additionalReqParams, inlineEditFlag } = this.props;
      if (additionalReqParams) data = { ...data, ...additionalReqParams };
      if (this.state.duplicateData)
        data = { ...data, ...this.state.duplicateData };
      Object.keys(data).map(function (key) {
        if (data[key] instanceof Array) {
          let value = data[key];
          data[key] = value;
        }
        return data;
      });
      // let jsonvar = data;
      // console.log("data= ", jsonvar);
      http
        .post("/studentsAcademicMultipleApproval", data)
        .then((response) => {
          if (response.status === 200) {
            const { message } = response.data;
            notifier.info(message.replace("^", "-"));
            if (!inlineEditFlag) this.loadData();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (data.univtrnsdtlstatus !== undefined) {
      console.log("data ", data);
      console.log("options ", options);
      const { additionalReqParams, inlineEditFlag } = this.props;
      if (additionalReqParams) data = { ...data, ...additionalReqParams };
      if (this.state.duplicateData)
        data = { ...data, ...this.state.duplicateData };
      Object.keys(data).map(function (key) {
        if (data[key] instanceof Array) {
          let value = data[key];
          data[key] = value;
        }
        return data;
      });
      // let jsonvar = data;
      // console.log("data= ", jsonvar);
      http
        .post("/academicpaymentMultipleConfirm", data)
        .then((response) => {
          if (response.status === 200) {
            const { message } = response.data;
            notifier.info(message.replace("^", "-"));
            if (!inlineEditFlag) this.loadData();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

  };

  downloadCSV = (e) => {
    this.ref.table.download(
      "csv",
      this.props.exportFileName +
      moment(new Date()).format(exportDateFormat) +
      ".csv"
    );
  };
  downloadExcel = (e) => {
    this.ref.table.download(
      "xlsx",
      this.props.exportFileName +
      moment(new Date()).format(exportDateFormat) +
      ".xlsx",
      {
        sheetName: this.props.exportFileName,
        documentProcessing: function (workbook) {
          return workbook;
        },
      }
    );
  };
  downloadpdf = (e) => {
    this.ref.table.download(
      "pdf",
      this.props.exportFileName +
      moment(new Date()).format(exportDateFormat) +
      ".pdf",
      {


        //orientation: "portrait",
        orientation: "landscape",
        title:
          this.props.actionLabel +
          " " +
          moment(new Date()).format(EXPORT_PROPERTIES.DISPLAY_DATE_FORMAT),
        documentProcessing: function (doc) {
          var totalPages = doc.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setTextColor(150);
            if (EXPORT_PROPERTIES.EXPORT_WATER_MARK_CONTENT) {
              doc.text(
                30,
                doc.internal.pageSize.height - 10,
                EXPORT_PROPERTIES.EXPORT_WATER_MARK_CONTENT
              );
            }
          }

          return doc;
        },

        autoTable: {
          styles: {
            //  overflow: 'linebreak', // Ensure text wraps to avoid overflow
            // cellPadding: 2,        // Adjust cell padding if needed
          },
          headStyles: {
            halign: 'left'      // Center align the header text
          },
          columnStyles: {
            0: { cellWidth: 10, halign: 'left' }, // ID
            1: { cellWidth: 40, halign: 'left' }, // Originating mission
            2: { cellWidth: 30, halign: 'left' }, // Event Type
            3: { cellWidth: 40, halign: 'left' }, // Event Request Name
            4: { cellWidth: 35, halign: 'left' }, // Status
            5: { cellWidth: 30, halign: 'left' }, // Last Entity
            6: { cellWidth: 30, halign: 'left' }, // From
            7: { cellWidth: 30, halign: 'left' }, // To
            8: { cellWidth: 30, halign: 'left' }, // Creator
            9: { cellWidth: 10, halign: 'left' }, // OnBehalfOf
            10: { cellWidth: 10, halign: 'left' }, // Event Cost
            11: { cellWidth: 80, halign: 'left' }, // Request Detail
            12: { cellWidth: 35, halign: 'left' }, // Created Time
            13: { cellWidth: 35, halign: 'left' } // Last Modified Time
          },
        },
      }
    );
  };

  toggleHelpWindow() {
    this.setState({ helpWindow: !this.state.helpWindow });
  }

  componentDidMount() {
    this._isMounted = true;
    const { refOption: options, getColumnOnly } = this.props;
    if (options && getColumnOnly !== true) this.loadData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const {
      id,
      selectable,
      movableRows,
      route,
      downloadOptions,
      addOption,
      editOption,
      ForwardOption,
      RejectOption,
      saveOption,
      submitOptions,
      saveOptionNe,
      saveOptionNeprofile,
      saveOptionDefaultProfile,
      saveOptionGuiProfile,
      deleteOption,
      actionLabel,
      inlineEditFlag,
      pagesize,
      pagelist,
      parentTableActionLabel,
      additionalOptions,
      exceldownloadmultipleview,
      exceldownloadOption,
      fields,
      groupBy,
      role
    } = this.props;
    let { columns, tableLayout, formOnChange, formOnBlur } = this.props;
    const {
      data,
      savemodal,
      large,
      danger,
      formTitle,
      formSchema,
      param,
      uiSchema,
      iconName,
      modalType,
      deletePopUp,
      saveprofiledet,
      submit,
      submitExp,
      submitPopUp,
      downloadButtonProp,
      editorDeleteButtonProp,
      editorSaveButtonProp,
      editorSubmitButtonProp,
      formData,
      formKey,
      helpWindow,
      key,
      loading,
    } = this.state;
    if (!formOnChange) formOnChange = console.log();
    if (!formOnBlur) formOnBlur = console.log();
    if (!tableLayout) tableLayout = "fitColumns";
    columns = [
      { formatter: "rownum", headerSort: false, width: 50 },
      ...columns,
    ];
    var errorMsg = parentTableActionLabel;
    if (parentTableActionLabel === undefined)
      errorMsg =
        "Please select a row from the " +
        parentTableActionLabel +
        " and then" +
        modalType.toLowerCase();
    else if (parentTableActionLabel.indexOf("^") === -1)
      errorMsg =
        "Please select a row from the " +
        parentTableActionLabel.toLowerCase() +
        " and then" +
        modalType.toLowerCase();
    else
      errorMsg =
        "Please " +
        parentTableActionLabel.replace("^", " ").toLowerCase() +
        " and then" +
        modalType.toLowerCase();
    // let helpFileName = "404.html";
    // if (exportFileName)
    //   helpFileName =
    //     exportFileName.toLowerCase().replace(/\n/g, "").replace(/-/g, "") +
    //     ".html";
    return (
      <React.Fragment>
        <ReactTabulatorWrapper
          ref={(ref) => (this.ref = ref)}
          ref1={this.ref}
          id={id + "_table"}
          key={id + key}
          columns={columns}
          className={"striped blue"}
          columnHeaderVertAlign={"bottom"}
          data={data}
          rowClick={this.rowClick}
          cellEdited={(cell) => this.inlineEdit(cell, saveOption, id, submitOptions)}
          // dataEdited={() => this.loadData1()}
          downloadReady={(fileContents, blob) => blob}
          footerElement={"#CButton_" + id}
          options={{
            height: "205",
            width: "100%",
            placeholder: "No Data Available",
            movableRows: movableRows ? false : true,
            pagination: "local",
            paginationSize: pagesize,
            paginationSizeSelector: pagelist,
            paginationAddRow: "table",
            paginationButtonCount: 2,
            selectable: selectable,
            resizableRows: true,
            tooltips: true,
            tooltipsHeader: true,
            tooltipGenerationMode: "hover",
            layout: tableLayout,
            redraw: true,
            persistence: false,
            persistenceID: id + "_Persistence",
            movableColumns: true,
            columnCalcs: "both",
            groupBy: groupBy,

            downloadConfig: {
              columnGroups: false, //include column groups in column headers for download
              rowGroups: false, //do not include row groups in download
              columnCalcs: true, //do not include column calculation rows in download
              dataTree: false, //do not include data tree in download
            },
            rowSelected: function (row) {
              row.getElement().setAttribute("style", "background-color: #9abcea !important")
              row.getElement().style.backgroundColor = "#9abcea  !important";
            },
            rowDeselected: function (row) {
              row.getElement().setAttribute("style", "background-color:inherit")
              row.getElement().setAttribute("style", "background-color: transparent")
              row.getElement().style.backgroundColor = "inherit";
              row.getElement().style.backgroundColor = "transparent";
            },
            // dataFiltered: function (filters, rows) {
            //   var el = document.getElementById("search_count");
            //   el.innerHTML = rows.length;
            // },
            // dataLoaded: function (data) {
            //   var el = document.getElementById("total_count");
            //   el.innerHTML = data.length;
            // },
          }}

          template='<div id="example-table"></div>'
        />
        <div className="tabulator-footer" id={"CButton_" + id}>
          <span className="tabulator-action">
            <div className="btn-group">
              {addOption && route.writeAccess === "1" && (
                <button
                  className="btn"
                  title="Add"
                  onClick={(addOption) => this.onOpenAddForm(addOption)}
                >
                  {/* <i className="fa fa-plus fa-border"></i> */}
                  <img src={addButton}></img>
                </button>
              )}
              {this.props.addGroupOption && route.writeAccess === "1" && (
                <button className="btn" title="Add Group" onClick={() => this.onOpenAddForm(this.props.addGroupOption)}>
                  <i className="fa fa-users" style={{ color: "green" }}></i>
                </button>
              )}
              {downloadOptions &&
                route.writeAccess === "1" &&
                (
                  <div className="btn-group">
                    <button
                      className="btn"
                      title="Sample document"
                      onClick={() => this.downloaddoc("Reload")}
                    >
                      {/* <FontAwesomeIcon icon={faSync} /> */}
                      <img src={downloadButton}></img>
                    </button>
                  </div>
                )}
              {editOption &&
                (route.writeAccess === "1" ||
                  (route.writeAccess === "0" && role === "DG" && id === "SurveyQestions")) &&
                inlineEditFlag !== "true" && (
                  <button
                    className="btn"
                    title={(this.props.editButtonTitle !== undefined) ? this.props.editButtonTitle : "Edit"}
                    disabled={(this.props.editorDeleteButtonProp !== undefined) ? this.props.editorDeleteButtonProp : editorDeleteButtonProp}
                    onClick={(editOption) => this.onOpenEditForm(editOption)}
                  >
                    {/* <i className="fa fa-edit fa-border"></i> */}
                    <img src={editButton}></img>
                  </button>
                )}
              {ForwardOption &&
                route.writeAccess === "1" &&
                inlineEditFlag !== "true" && (
                  <button
                    className="btn"
                    title="Forward"
                    disabled={editorDeleteButtonProp}
                    onClick={(ForwardOption) => this.onOpenForwardEditForm(ForwardOption)}
                  >
                    {/* <i class="fa-solid fa-forward"></i> */}
                    {/* <i className="fa fa-edit fa-border"></i> */}
                    <img src={forwardButton}></img>
                  </button>
                )}
              {RejectOption &&
                route.writeAccess === "1" &&
                inlineEditFlag !== "true" && (
                  <button
                    className="btn"
                    title="Reject"
                    disabled={editorDeleteButtonProp}
                    onClick={(RejectOption) => this.onRejectEditForm(RejectOption)}
                  >
                    {/* <i className="fa fa-edit fa-border"></i> */}
                    <img src={rejectButton}></img>
                  </button>
                )}

              {saveOption && route.writeAccess === "1" && (
                <button
                  className="btn"
                  title="Save"
                  disabled={editorSaveButtonProp}
                  onClick={(saveOption) => this.onOpenSaveForm(saveOption, id)}
                >
                  {/* <i className="fa fa-trash fa-border"></i> */}
                  <img src={saveButton} width="16px" height="16px"></img>
                </button>
              )}
              {submitOptions && route.writeAccess === "1" && (
                <button
                  className="btn"
                  title="Submit"
                  disabled={editorSubmitButtonProp}
                  onClick={(submitOptions) => this.onOpenSubmitForm(submitOptions, id)}
                >
                  <img src={submitButton} width="16px" height="16px"></img>
                </button>
              )}

              {saveOptionNe && route.writeAccess === "1" && (
                <button
                  className="btn"
                  title="Save"
                  disabled={editorSaveButtonProp}
                  onClick={(saveOptionNe) => this.onOpenSaveNeForm(saveOptionNe)}
                >
                  {/* <i className="fa fa-trash fa-border"></i> */}
                  <img src={saveButton} width="16px" height="16px"></img>
                </button>
              )}

              {saveOptionDefaultProfile && route.writeAccess === "1" && (
                <button
                  className="btn"
                  title="Save"
                  disabled={editorSaveButtonProp}
                  onClick={(saveOptionDefaultProfile) => this.onOpenSaveDefaultProfileForm(saveOptionDefaultProfile)}
                >
                  {/* <i className="fa fa-trash fa-border"></i> */}
                  <img src={saveButton} width="16px" height="16px"></img>
                </button>
              )}

              {saveOptionNeprofile && route.writeAccess === "1" && (
                <button
                  className="btn"
                  title="Save"
                  disabled={editorSaveButtonProp}
                  onClick={(saveOptionNeprofile) => this.onOpenSaveNeProfileForm(saveOptionNeprofile)}
                >
                  {/* <i className="fa fa-trash fa-border"></i> */}
                  <img src={saveButton} width="16px" height="16px"></img>
                </button>
              )}


              {saveOptionGuiProfile && route.writeAccess === "1" && (
                <button
                  className="btn"
                  title="Save"
                  disabled={editorSaveButtonProp}
                  onClick={(saveOptionGuiProfile) => this.onOpenSaveGuiProfileForm(saveOptionGuiProfile)}
                >
                  {/* <i className="fa fa-trash fa-border"></i> */}
                  <img src={saveButton} width="16px" height="16px"></img>
                </button>
              )}





              {deleteOption && route.writeAccess === "1" && (
                <button
                  className="btn"
                  title={(this.props.deleteButtonTitle !== undefined) ? this.props.deleteButtonTitle : "Delete"}
                  disabled={(this.props.editorDeleteButtonProp !== undefined) ? this.props.editorDeleteButtonProp : editorDeleteButtonProp}
                  onClick={(deleteOption) =>
                    this.onOpenDeleteForm(deleteOption)
                  }
                >
                  {/* <i className="fa fa-trash fa-border"></i> */}
                  <img src={deleteButton}></img>
                </button>
              )}


              {additionalOptions &&
                route.writeAccess === "1" &&
                additionalOptions.map((option) => (
                  <button
                    key={option.iconName}
                    className="btn"
                    title={option.iconName}
                    disabled={editorDeleteButtonProp}
                    onClick={() => this.handleAdditionalOptionsClick(option.iconName)}
                  >
                    <i className={"fa fa-border " + option.iconClass}></i>
                  </button>
                ))}
              {/*{pdfOption && route.writeAccess === "1" && (
                <button
                  className="btn"
                  editorPDFButtonProp
                  title="Upload PDF"
                  disabled={editorPDFButtonProp}
                  onClick={(pdfOption) => this.props.onOpenPDFForm(pdfOption)}
                >
                  <i className="fa fa-file-pdf-o fa-border"></i>
                </button>
              )}
              {gifOption && route.writeAccess === "1" && (
                <button
                  className="btn"
                  editorGIFButtonProp
                  title="Save and Record GIF"
                  disabled={editorGIFButtonProp}
                  onClick={(gifOption) => this.props.onOpenGIFForm(gifOption)}
                >
                  <i className="fa fa-spinner fa-border"></i>
                </button>
              )} */}
            </div>

            <div className="btn-group">
              <button
                className="btn"
                title="Reload"
                onClick={() => this.loadData("Reload")}
              >
                {/* <FontAwesomeIcon icon={faSync} /> */}
                <img src={reloadButton}></img>
              </button>
            </div>
            {/*
            <div className="btn-group">
              <button
                className="btn"
                title="CSV"
                onClick={() => this.downloadCSV()}
                disabled={downloadButtonProp}
              >
      */}
            {/* <FontAwesomeIcon icon={faFileCsv} /> */}
            {/*
                <img src={csvButton}></img>
              </button>
      */}
            <button
              className="btn"
              title="Excel"
              onClick={this.props.downloadExcelHandler || (() => this.downloadExcel())}
              disabled={this.props.downloadButtonProp || downloadButtonProp}
            >
              {/* <FontAwesomeIcon icon={faFileExcel} /> */}
              <img src={excelButton}></img>
            </button>


            {exceldownloadOption && route.writeAccess === "1" && (
              <button
                className="btn"
                title="Normal Excel Report"
                onClick={(() => this.downloadExcel())}
                disabled={this.props.downloadButtonProp || downloadButtonProp}
              >
                <img src={excelButton}></img>
              </button>
            )}


            {exceldownloadmultipleview && route.writeAccess === "1" && (
              <button
                className="btn"
                title="Report"
                onClick={(() => this.downloadExcel())}
                disabled={this.props.downloadButtonProp || downloadButtonProp}
              >
                {/* <i className="fa fa-plus fa-border"></i> */}
                <img src={excelButton}></img>
              </button>
            )}

            {(id === "artistDetails" || id === "EventRequest" || id === "EventRequestTrail" || id === "EventRequestReport" || id === "Contacts") && (
              <div className="btn-group">
                <button
                  className="btn"
                  title="PDF"
                  onClick={() => this.downloadpdf()}
                  disabled={downloadButtonProp}
                >
                  {/* <FontAwesomeIcon icon={faFilePdf} /> */}

                  <img src={pdfButton}></img>
                </button>
              </div>
            )}

            {/*
              <button
                className="btn"
                title="PDF"
                onClick={() => this.downloadpdf()}
                disabled={downloadButtonProp}
              >
      */}
            {/* <FontAwesomeIcon icon={faFilePdf} /> */}
            {/*
                <img src={pdfButton}></img>
              </button>
            </div>
      */}
            {/* <div className="btn-group">
              <button
                className="btn"
                title="Help"
                onClick={this.toggleHelpWindow}
              >
                {/* <FontAwesomeIcon icon={faQuestionCircle} /> */}
            {/* <img src={helpButton} width="16px" height="16px"></img>
                {/* <i className="fa fa-question-circle" aria-hidden="true"></i> */}
            {/* {"  "} */}
            {/* </button> */}
            {/* </div>   */}
          </span>
          {/* <span style="color:#102D4F;font-size:12px;font-family:Arial, Helvetica, sans-serif">
            Showing <span id="search_count"></span> results in total <span id="total_count"></span>
          </span> */}

          {this.state.loading && (
            <Spinner type="grow" color="primary" size="sm" children="Loading..."></Spinner>
          )}

        </div>
        <Modal
          isOpen={large}
          toggle={this.toggleLarge}
          className={"modal-lg " + this.props.className}
        >
          <ModalHeader toggle={this.toggleLarge}>{formTitle}</ModalHeader>
          <ModalBody>
            {/* {JSON.stringify(formSchema)} */}
            <Form
              {...this.props}
              key={formKey}
              id={id + "_form"}
              formData={iconName === "ADD" ? [] : formData}
              schema={formSchema}
              parameter={param}
              uiSchema={uiSchema}
              fields={fields !== undefined ? fields : CFormFields}
              widgets={customWidgets}
              onSubmit={(e) => this.handleSubmit(e, this.props)}
              onChange={(e) => this.handleChange(e, this.props)} //formOnChange}
              onBlur={(e) => this.handleblur(e, this.props)}
              noHtml5Validate={true}
              customFormats={customFormats}
              transformErrors={transformErrors}
              showErrorList={false}
              liveValidate={true}
              additionalMetaSchemas={[additionalMetaSchemas]}
            >
              <div className="col-sm-12 text-right">
                <button type="submit" className="btn btn-sm btn-primary">
                  {iconName}
                </button>
                <button
                  type="button"
                  onClick={() => this.toggleLarge()}
                  className="btn btn-sm btn-default"
                >
                  Cancel
                </button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={savemodal}
          toggle={this.togglesaveModal}
          className={"modal-lg " + this.props.className}
        >
          <ModalHeader toggle={this.togglesaveModal}>{formTitle}</ModalHeader>
          <ModalBody>
            {/* {JSON.stringify(formSchema)} */}
            <Form
              {...this.props}
              key={formKey}
              id={id + "_form"}
              formData={iconName === "ADD" ? [] : formData}
              schema={formSchema}
              parameter={param}
              uiSchema={uiSchema}
              fields={fields !== undefined ? fields : CFormFields}
              widgets={customWidgets}
              onSubmit={(e) => this.handleattendaneSubmit(e, this.props)}
              // onChange={(e) => this.handleChange(e, this.props)} //formOnChange}
              // onBlur={(e) => this.handleblur(e, this.props)}
              noHtml5Validate={true}
              customFormats={customFormats}
              transformErrors={transformErrors}
              showErrorList={false}
              liveValidate={true}
              additionalMetaSchemas={[additionalMetaSchemas]}
            >
              <div className="col-sm-12 text-right">
                <button type="submit" className="btn btn-sm btn-primary">
                  {iconName}
                </button>
                <button
                  type="button"
                  onClick={() => this.togglesaveModal()}
                  className="btn btn-sm btn-default"
                >
                  Cancel
                </button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={danger}
          toggle={this.toggleDanger}
          className={"modal-danger " + this.props.className}
        >
          <ModalHeader toggle={this.toggleDanger}>Information</ModalHeader>
          <ModalBody>{errorMsg}</ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.toggleDanger}>
              Ok
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={deletePopUp}
          toggle={this.toggleDelete}
          className={"modal-sm " + this.props.className}
        >
          <ModalHeader toggle={this.toggleDelete}>{formTitle}</ModalHeader>
          <ModalBody>{COMMON_PROPERTIES.DELETE_MSG + actionLabel}</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => this.onDeleteRecord()}>
              Ok
            </Button>
            <Button color="secondary" onClick={this.toggleDelete}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={saveprofiledet}
          toggle={this.toggleSaveProfile}
          className={"modal-sm " + this.props.className}
        >
          <ModalHeader toggle={this.toggleSaveProfile}>{COMMON_PROPERTIES.INFORMATION}</ModalHeader>
          {(id === "SurveyQestions" && saveOption &&
            <ModalBody>{"Please enable the checkbox state and then Save"}</ModalBody>) || (
              (id === "SurveyQestions" && submitOptions &&
                <ModalBody>{"Please enable the checkbox state and then Submit"}</ModalBody>) || (
                (id === "RecordMonthlyReceiptExpenditure" && submitOptions &&
                  <ModalBody>{"Recording Monthly Receipts & Expenditures was completed"}</ModalBody>) ||
                (id === "RecordMonthlyReceiptExpenditure" && saveOption &&
                  <ModalBody>{"Please enter the amount to save"}</ModalBody>) || (
                  <ModalBody>{COMMON_PROPERTIES.EXPENDITURE_STATUS_MESSAGE_ENABLE}</ModalBody>
                )
              ))}
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleSaveProfile}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={submitPopUp}
          toggle={this.togglePost}
          className={"modal-sm " + this.props.className}
        >
          <ModalHeader toggle={this.toggleSubmit}>{COMMON_PROPERTIES.INFORMATION}</ModalHeader>
          <ModalBody>{COMMON_PROPERTIES.SUBMIT_MSG}</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => this.onSubmitRecord()}>
              Ok
            </Button>
            <Button color="secondary" onClick={this.toggleSubmit}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={submit}
          toggle={this.toggleSubmitSurvey}
          className={"modal-sm " + this.props.className}
        >
          <ModalHeader toggle={this.toggleSubmitSurvey}>{COMMON_PROPERTIES.INFORMATION}</ModalHeader>
          <ModalBody>Survey already completed</ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleSubmitSurvey}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={submitExp}
          toggle={this.toggleSubmitExpenditure}
          className={"modal-sm " + this.props.className}
        >
          <ModalHeader toggle={this.toggleSubmitExpenditure}>{COMMON_PROPERTIES.INFORMATION}</ModalHeader>
          <ModalBody>Expenditure already completed</ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleSubmitExpenditure}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        <div id="mySidenav" className="mySidenav">
          <span
            id="helpWindow"
            className={
              helpWindow === true
                ? "border border-secondary active"
                : "border border-secondary inactive"
            }
            style={{ top: "10%" }}
          >
            <img src={cancel} alt={"Missing"} onClick={this.toggleHelpWindow} />
            {helpWindow && (
              // <Iframe
              //   src={"./html/" + helpFileName}
              //   id="myId"
              //   className="helpFrame"
              //   display="initial"
              //   position="relative"
              //   overflow="scroll"
              // />
              <React.Fragment>
                <h1>Help</h1>
                <h2>header 1</h2>
                <h3>header 2</h3>
                <h4>Content</h4>
              </React.Fragment>
            )}
          </span>
        </div>
      </React.Fragment>
    );
  }
}
export default CTable;
